import _possibleConstructorReturn from "/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/builds/a8-megtag/a8chat-console-web/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * The unique id is used for unique hashes.
 */
var uniqueId = 0;
/**
 * Quick dictionary lookup for unit-less numbers.
 */

var CSS_NUMBER = Object.create(null);
/**
 * CSS properties that are valid unit-less numbers.
 *
 * Ref: https://github.com/facebook/react/blob/master/packages/react-dom/src/shared/CSSProperty.js
 */

var CSS_NUMBER_KEYS = ["animation-iteration-count", "border-image-outset", "border-image-slice", "border-image-width", "box-flex", "box-flex-group", "box-ordinal-group", "column-count", "columns", "counter-increment", "counter-reset", "flex", "flex-grow", "flex-positive", "flex-shrink", "flex-negative", "flex-order", "font-weight", "grid-area", "grid-column", "grid-column-end", "grid-column-span", "grid-column-start", "grid-row", "grid-row-end", "grid-row-span", "grid-row-start", "line-clamp", "line-height", "opacity", "order", "orphans", "tab-size", "widows", "z-index", "zoom", // SVG properties.
"fill-opacity", "flood-opacity", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-miterlimit", "stroke-opacity", "stroke-width"]; // Add vendor prefixes to all unit-less properties.

for (var _i = 0, _CSS_NUMBER_KEYS = CSS_NUMBER_KEYS; _i < _CSS_NUMBER_KEYS.length; _i++) {
  var property = _CSS_NUMBER_KEYS[_i];

  for (var _i2 = 0, _arr = ["-webkit-", "-ms-", "-moz-", "-o-", ""]; _i2 < _arr.length; _i2++) {
    var prefix = _arr[_i2];
    CSS_NUMBER[prefix + property] = true;
  }
}
/**
 * Escape a CSS class name.
 */


function escape(str) {
  return str.replace(/[ !#$%&()*+,./;<=>?@[\]^`{|}~"'\\]/g, "\\$&");
}
/**
 * Transform a JavaScript property into a CSS property.
 */


function hyphenate(propertyName) {
  return propertyName.replace(/[A-Z]/g, function (m) {
    return "-".concat(m.toLowerCase());
  }).replace(/^ms-/, "-ms-"); // Internet Explorer vendor prefix.
}
/**
 * Generate a hash value from a string.
 */


function stringHash(str) {
  var value = 5381;
  var len = str.length;

  while (len--) {
    value = value * 33 ^ str.charCodeAt(len);
  }

  return (value >>> 0).toString(36);
}
/**
 * Transform a style string to a CSS string.
 */


function styleToString(key, value) {
  if (value && typeof value === "number" && !CSS_NUMBER[key]) {
    return "".concat(key, ":").concat(value, "px");
  }

  return "".concat(key, ":").concat(value);
}
/**
 * Sort an array of tuples by first value.
 */


function sortTuples(value) {
  return value.sort(function (a, b) {
    return a[0] > b[0] ? 1 : -1;
  });
}
/**
 * Categorize user styles.
 */


function parseStyles(styles, hasNestedStyles) {
  var properties = [];
  var nestedStyles = []; // Sort keys before adding to styles.

  for (var _i3 = 0, _Object$keys = Object.keys(styles); _i3 < _Object$keys.length; _i3++) {
    var _key = _Object$keys[_i3];

    var name = _key.trim();

    var value = styles[_key];

    if (name.charCodeAt(0) !== 36
    /* $ */
    && value != null) {
      if (typeof value === "object" && !Array.isArray(value)) {
        nestedStyles.push([name, value]);
      } else {
        properties.push([hyphenate(name), value]);
      }
    }
  }

  return {
    style: stringifyProperties(sortTuples(properties)),
    nested: hasNestedStyles ? nestedStyles : sortTuples(nestedStyles),
    isUnique: !!styles.$unique
  };
}
/**
 * Stringify an array of property tuples.
 */


function stringifyProperties(properties) {
  return properties.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    if (!Array.isArray(value)) return styleToString(name, value);
    return value.map(function (x) {
      return styleToString(name, x);
    }).join(";");
  }).join(";");
}
/**
 * Interpolate CSS selectors.
 */


function interpolate(selector, parent) {
  if (selector.indexOf("&") === -1) return "".concat(parent, " ").concat(selector);
  return selector.replace(/&/g, parent);
}
/**
 * Recursive loop building styles with deferred selectors.
 */


function stylize(selector, styles, rulesList, stylesList, parent) {
  var _parseStyles = parseStyles(styles, selector !== ""),
      style = _parseStyles.style,
      nested = _parseStyles.nested,
      isUnique = _parseStyles.isUnique;

  var pid = style;

  if (selector.charCodeAt(0) === 64
  /* @ */
  ) {
    var child = {
      selector: selector,
      styles: [],
      rules: [],
      style: parent ? "" : style
    };
    rulesList.push(child); // Nested styles support (e.g. `.foo > @media > .bar`).

    if (style && parent) {
      child.styles.push({
        selector: parent,
        style: style,
        isUnique: isUnique
      });
    }

    var _iterator = _createForOfIteratorHelper(nested),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            name = _step$value[0],
            value = _step$value[1];

        pid += name + stylize(name, value, child.rules, child.styles, parent);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    var _key2 = parent ? interpolate(selector, parent) : selector;

    if (style) stylesList.push({
      selector: _key2,
      style: style,
      isUnique: isUnique
    });

    var _iterator2 = _createForOfIteratorHelper(nested),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
            _name = _step2$value[0],
            _value = _step2$value[1];

        pid += _name + stylize(_name, _value, rulesList, stylesList, _key2);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return pid;
}
/**
 * Transform `stylize` tree into style objects.
 */


function composeStylize(cache, pid, rulesList, stylesList, className, isStyle) {
  var _iterator3 = _createForOfIteratorHelper(stylesList),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _step3.value,
          selector = _step3$value.selector,
          style = _step3$value.style,
          isUnique = _step3$value.isUnique;

      var _key3 = isStyle ? interpolate(selector, className) : selector;

      var id = isUnique ? "u\0".concat((++uniqueId).toString(36)) : "s\0".concat(pid, "\0").concat(style);
      var item = new Style(style, id);
      item.add(new Selector(_key3, "k\0".concat(pid, "\0").concat(_key3)));
      cache.add(item);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var _iterator4 = _createForOfIteratorHelper(rulesList),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _step4$value = _step4.value,
          _selector = _step4$value.selector,
          _style = _step4$value.style,
          rules = _step4$value.rules,
          styles = _step4$value.styles;

      var _item = new Rule(_selector, _style, "r\0".concat(pid, "\0").concat(_selector, "\0").concat(_style));

      composeStylize(_item, pid, rules, styles, className, isStyle);
      cache.add(_item);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}
/**
 * Cache to list to styles.
 */


function join(arr) {
  var res = "";

  for (var i = 0; i < arr.length; i++) {
    res += arr[i];
  }

  return res;
}
/**
 * Noop changes.
 */


var noopChanges = {
  add: function add() {
    return undefined;
  },
  change: function change() {
    return undefined;
  },
  remove: function remove() {
    return undefined;
  }
};
/**
 * Implement a cache/event emitter.
 */

export var Cache = /*#__PURE__*/function () {
  function Cache() {
    var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noopChanges;

    _classCallCheck(this, Cache);

    this.changes = changes;
    this.sheet = [];
    this.changeId = 0;
    this._keys = [];
    this._children = Object.create(null);
    this._counters = Object.create(null);
  }

  _createClass(Cache, [{
    key: "add",
    value: function add(style) {
      var count = this._counters[style.id] || 0;
      var item = this._children[style.id] || style.clone();
      this._counters[style.id] = count + 1;

      if (count === 0) {
        this._children[item.id] = item;

        this._keys.push(item.id);

        this.sheet.push(item.getStyles());
        this.changeId++;
        this.changes.add(item, this._keys.length - 1);
      } else if (item instanceof Cache && style instanceof Cache) {
        var curIndex = this._keys.indexOf(style.id);

        var prevItemChangeId = item.changeId;
        item.merge(style);

        if (item.changeId !== prevItemChangeId) {
          this.sheet.splice(curIndex, 1, item.getStyles());
          this.changeId++;
          this.changes.change(item, curIndex, curIndex);
        }
      }
    }
  }, {
    key: "remove",
    value: function remove(style) {
      var count = this._counters[style.id];

      if (count) {
        this._counters[style.id] = count - 1;
        var item = this._children[style.id];

        var index = this._keys.indexOf(item.id);

        if (count === 1) {
          delete this._counters[style.id];
          delete this._children[style.id];

          this._keys.splice(index, 1);

          this.sheet.splice(index, 1);
          this.changeId++;
          this.changes.remove(item, index);
        } else if (item instanceof Cache && style instanceof Cache) {
          var prevChangeId = item.changeId;
          item.unmerge(style);

          if (item.changeId !== prevChangeId) {
            this.sheet.splice(index, 1, item.getStyles());
            this.changeId++;
            this.changes.change(item, index, index);
          }
        }
      }
    }
  }, {
    key: "values",
    value: function values() {
      var _this = this;

      return this._keys.map(function (key) {
        return _this._children[key];
      });
    }
  }, {
    key: "merge",
    value: function merge(cache) {
      var _iterator5 = _createForOfIteratorHelper(cache.values()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var item = _step5.value;
          this.add(item);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return this;
    }
  }, {
    key: "unmerge",
    value: function unmerge(cache) {
      var _iterator6 = _createForOfIteratorHelper(cache.values()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var item = _step6.value;
          this.remove(item);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Cache().merge(this);
    }
  }]);

  return Cache;
}();
/**
 * Selector is a dumb class made to represent nested CSS selectors.
 */

export var Selector = /*#__PURE__*/function () {
  function Selector(selector, id) {
    _classCallCheck(this, Selector);

    this.selector = selector;
    this.id = id;
  }

  _createClass(Selector, [{
    key: "getStyles",
    value: function getStyles() {
      return this.selector;
    }
  }, {
    key: "clone",
    value: function clone() {
      return this;
    }
  }]);

  return Selector;
}();
/**
 * The style container registers a style string with selectors.
 */

export var Style = /*#__PURE__*/function (_Cache) {
  _inherits(Style, _Cache);

  function Style(style, id) {
    var _this2;

    _classCallCheck(this, Style);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Style).call(this));
    _this2.style = style;
    _this2.id = id;
    return _this2;
  }

  _createClass(Style, [{
    key: "getStyles",
    value: function getStyles() {
      return "".concat(this.sheet.join(","), "{").concat(this.style, "}");
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Style(this.style, this.id).merge(this);
    }
  }]);

  return Style;
}(Cache);
/**
 * Implement rule logic for style output.
 */

export var Rule = /*#__PURE__*/function (_Cache2) {
  _inherits(Rule, _Cache2);

  function Rule(rule, style, id) {
    var _this3;

    _classCallCheck(this, Rule);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Rule).call(this));
    _this3.rule = rule;
    _this3.style = style;
    _this3.id = id;
    return _this3;
  }

  _createClass(Rule, [{
    key: "getStyles",
    value: function getStyles() {
      return "".concat(this.rule, "{").concat(this.style).concat(join(this.sheet), "}");
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Rule(this.rule, this.style, this.id).merge(this);
    }
  }]);

  return Rule;
}(Cache);

function key(pid, styles) {
  var key = "f".concat(stringHash(pid));
  if (process.env.NODE_ENV === "production" || !styles.$displayName) return key;
  return "".concat(styles.$displayName, "_").concat(key);
}
/**
 * The FreeStyle class implements the API for everything else.
 */


export var FreeStyle = /*#__PURE__*/function (_Cache3) {
  _inherits(FreeStyle, _Cache3);

  function FreeStyle(id, changes) {
    var _this4;

    _classCallCheck(this, FreeStyle);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(FreeStyle).call(this, changes));
    _this4.id = id;
    return _this4;
  }

  _createClass(FreeStyle, [{
    key: "registerStyle",
    value: function registerStyle(styles) {
      var rulesList = [];
      var stylesList = [];
      var pid = stylize("&", styles, rulesList, stylesList);
      var id = key(pid, styles);
      var selector = ".".concat(process.env.NODE_ENV === "production" ? id : escape(id));
      composeStylize(this, pid, rulesList, stylesList, selector, true);
      return id;
    }
  }, {
    key: "registerKeyframes",
    value: function registerKeyframes(keyframes) {
      return this.registerHashRule("@keyframes", keyframes);
    }
  }, {
    key: "registerHashRule",
    value: function registerHashRule(prefix, styles) {
      var rulesList = [];
      var stylesList = [];
      var pid = stylize("", styles, rulesList, stylesList);
      var id = key(pid, styles);
      var selector = "".concat(prefix, " ").concat(process.env.NODE_ENV === "production" ? id : escape(id));
      var rule = new Rule(selector, "", "h\0".concat(pid, "\0").concat(prefix));
      composeStylize(rule, pid, rulesList, stylesList, "", false);
      this.add(rule);
      return id;
    }
  }, {
    key: "registerRule",
    value: function registerRule(rule, styles) {
      var rulesList = [];
      var stylesList = [];
      var pid = stylize(rule, styles, rulesList, stylesList);
      composeStylize(this, pid, rulesList, stylesList, "", false);
    }
  }, {
    key: "registerCss",
    value: function registerCss(styles) {
      return this.registerRule("", styles);
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      return join(this.sheet);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new FreeStyle(this.id, this.changes).merge(this);
    }
  }]);

  return FreeStyle;
}(Cache);
/**
 * Exports a simple function to create a new instance.
 */

export function create(changes) {
  return new FreeStyle("f".concat((++uniqueId).toString(36)), changes);
}